import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-100">
          <span className="text-gold font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-101">
            El Secreto Revelado
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy-900 mb-8" data-id="element-102">
            La solución se llama{' '}
            <span className="text-gold block mt-2" data-id="element-103">"Digital Quick-Launch"</span>
          </h2>

          <div className="bg-cream p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100 text-left space-y-6" data-id="element-104">
            <p className="text-xl text-slate-700 leading-relaxed" data-id="element-105">
              En lugar de productos físicos, vendemos{' '}
              <strong className="text-navy-900" data-id="element-106">
                "soluciones de bolsillo" en formato PDF
              </strong>
              .
            </p>

            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-107">
              Son archivos que creas una sola vez y se venden de forma
              automática las 24 horas del día.{' '}
              <span className="bg-gold/10 text-navy-900 font-semibold px-2 py-1 rounded" data-id="element-108">
                No requieren envíos, no se agotan y el margen de ganancia es
                casi del 100%
              </span>{' '}
              porque el costo de entrega es cero.
            </p>

            <p className="text-lg text-slate-600 leading-relaxed font-medium" data-id="element-109">
              Es el negocio perfecto para la mujer latina que domina el celular
              pero no tiene tiempo para complicaciones técnicas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}